module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Edit-0e3115882e978806a0971e743da51465.svg";